import SalesHeader from '../components/DataTable/StatisticsSalesHeader';
import SoldCell from '../components/DataTable/StatisticsSalesSoldCell';
import ExpandCell from '../components/DataTable/ExpandCell';
import ProfileCell from '../components/DataTable/ProfileCell';
import MultiLineHeader from '../components/DataTable/MultiLineHeader';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for statistics sales table
 */
export default {
    headerComponent: SalesHeader,
    columns: [
        {
            columnName: '_spacer',
            displayName: '',
            headerDataAttrs: {
                [DATA_TITLE]: 'expand'
            },
            customCell: ExpandCell
        },
        {
            columnName: 'sire_style_name',
            displayName: 'Sire',
            headerDataAttrs: {
                [DATA_TITLE]: 'sire'
            },
            customCell: {
                component: ProfileCell,
                options: {
                    profileType: 'horse',
                    columnUid: 'sire_uid',
                    columnStyleName: 'sire_style_name'
                }
            }
        },
        {
            columnName: 'total_count',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'CATD'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'catd'
            }
        },
        {
            columnName: 'offered_count',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'OFFD'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'offd'
            }
        },
        {
            columnName: 'sold_percent',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'SOLD (%)'
                        }
                    ]
                }
            },
            customCell: {
                component: SoldCell,
                options: {
                    columnSold: 'sales_count',
                    columnPercentage: 'sold_percent',
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'sold_percent'
            }
        },
        {
            columnName: 'price_total',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Aggregate'
                        },
                        {
                            text: `sales ${rootData.currency ? `(${rootData.currency})` : ''}`
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'aggregate_sales'
            }
        },
        {
            columnName: 'price_average',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Avg.'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'average'
            }
        },
        {
            columnName: 'price_max',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'High'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'high'
            }
        },
        {
            columnName: 'median',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Median'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'median'
            }
        },
        {
            columnName: 'price_min',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${rootData.currency ? ` (${rootData.currency})` : ''}`
                        },
                        {
                            text: 'Low'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'low'
            }
        },
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/statisticsSiresTable.js